export function countTruthy(values = []) {
  return values.filter(Boolean).length;
}

export function buildColumnSection({
  id = "columns",
  title = "Görüntülenen Sütunlar",
  columns = [],
  visibleColumns = [],
  onToggle,
  onReset,
  defaultOpen = true,
}) {
  if (!columns?.length || !onToggle) return null;
  return {
    id,
    type: "columns",
    title,
    columns,
    visibleColumns,
    onToggle,
    onReset,
    defaultOpen,
  };
}

export function buildRadioFilterSection({
  id,
  title,
  value,
  onChange,
  options = [],
  defaultOpen = true,
  searchPlaceholder = "Ara...",
}) {
  return {
    id,
    type: "radio",
    title,
    value: value ?? "",
    onChange,
    options,
    defaultOpen,
    searchPlaceholder,
  };
}

/** Searchable combobox-style filter for long option lists (single or multi). */
export function buildPickerFilterSection({
  id,
  title,
  mode = "single",
  value,
  selectedIds = [],
  onChange,
  options = [],
  allValue = "",
  allLabel = "Tümü",
  showAllOption = true,
  searchPlaceholder = "Ara...",
  emptyHint = "Aramak için yazın",
  emptyResultsLimit = 8,
  recentStorageKey = null,
  defaultOpen = true,
  loadOptions = null,
}) {
  return {
    id,
    type: "picker",
    title,
    mode,
    value: value ?? "",
    selectedIds,
    onChange,
    options,
    allValue,
    allLabel,
    showAllOption,
    searchPlaceholder,
    emptyHint,
    emptyResultsLimit,
    recentStorageKey: recentStorageKey ?? (id ? `filter_recent_${id}` : null),
    defaultOpen,
    loadOptions,
  };
}

/** Uses picker when options exceed threshold, otherwise radio (short enums). */
export function buildAdaptiveSingleFilterSection({
  pickerThreshold = 8,
  ...config
}) {
  const { options = [], allValue = "" } = config;
  const entityOptions = options.filter(
    (o) =>
      o.value !== "" &&
      o.value != null &&
      (allValue === "" || o.value !== allValue),
  );
  if (entityOptions.length > pickerThreshold) {
    return buildPickerFilterSection({
      mode: "single",
      ...config,
      options: entityOptions,
    });
  }
  return buildRadioFilterSection(config);
}

/** Uses picker when options exceed threshold, otherwise multiList. */
export function buildAdaptiveMultiFilterSection({
  pickerThreshold = 8,
  ...config
}) {
  const { options = [] } = config;
  if (options.length > pickerThreshold) {
    return buildPickerFilterSection({ mode: "multi", ...config });
  }
  return buildMultiListFilterSection(config);
}

export function buildMultiListFilterSection({
  id,
  title,
  selectedIds = [],
  onChange,
  options = [],
  showAllOption = true,
  allLabel = "Tümü",
  defaultOpen = true,
  searchPlaceholder = "Ara...",
}) {
  return {
    id,
    type: "multiList",
    title,
    selectedIds,
    onChange,
    options,
    showAllOption,
    allLabel,
    defaultOpen,
    searchPlaceholder,
  };
}

export function buildPeriodDateSection({
  id = "period",
  title = "Tarih",
  mode = "day",
  anchorDate,
  startDate,
  endDate,
  onChange,
  maxDate,
  defaultOpen = true,
}) {
  return {
    id,
    type: "periodDate",
    title,
    mode,
    anchorDate,
    startDate,
    endDate,
    onChange,
    maxDate,
    defaultOpen,
  };
}

export function buildDateRangeSection({
  id = "dates",
  title = "Tarih Aralığı",
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  defaultOpen = true,
}) {
  return {
    id,
    type: "dateRange",
    title,
    startDate,
    endDate,
    onStartChange,
    onEndChange,
    defaultOpen,
  };
}

export function buildSearchSection({
  id,
  title,
  value,
  onChange,
  placeholder = "",
  defaultOpen = true,
}) {
  return {
    id,
    type: "search",
    title,
    value,
    onChange,
    placeholder,
    defaultOpen,
  };
}
